import React from "react";
import Facebook from "../../assets/facebook.svg";
import Twitter from "../../assets/twitter.svg";
import Instagram from "../../assets/instagram.svg";

const SocialLinks = () => {
  return (
    <div className="social-links">
      <a className="social-links__link" target="_blank" href="https://www.facebook.com/evo">
        <Facebook className="social-links__logo" />
      </a>
      <a className="social-links__link" target="_blank" href="https://twitter.com/evogear">
        <Twitter className="social-links__logo" />
      </a>
      <a className="social-links__link" target="_blank" href="https://instagram.com/evo">
        <Instagram className="social-links__logo" />
      </a>
    </div>
  )
}

export default SocialLinks
